"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeCustomMetricsSender = void 0;
const types_1 = require("./types");
function mergeTags(globalTags, localTags = []) {
    const mergedTags = [...globalTags, ...localTags];
    return Array.from(new Set(mergedTags));
}
function makeCustomMetricsSender() {
    let _integrations = [];
    let _globalTags = [];
    let _namespace;
    let _service;
    function isValidDotSyntax(name) {
        const segments = name.split('.');
        const hasLessThanThreeSegments = segments.length < 3;
        return !hasLessThanThreeSegments;
    }
    function isValidDoubleUnderscoreSyntax(name) {
        const segments = name.split('__');
        const hasLessThanThreeSegments = segments.length < 3;
        return !hasLessThanThreeSegments;
    }
    function getMetricNameSegments(name) {
        return name.includes('__') ? name.split('__') : name.split('.');
    }
    function validateMetricName(name) {
        if (!isValidDotSyntax(name) && !isValidDoubleUnderscoreSyntax(name)) {
            // eslint-disable-next-line @glovo/no-console
            console.warn(`Invalid metric name ('${name}'). It should start with: ${_namespace}.${_service}.* OR ${_namespace}__${_service}__* and contain at least one extra segment`);
        }
        const [namespace, service] = getMetricNameSegments(name);
        if (_namespace !== namespace) {
            // eslint-disable-next-line @glovo/no-console
            console.warn(`Invalid metric name ('${name}'). Namespace ('${namespace}') should be '${_namespace}'`);
        }
        if (_service !== service) {
            // eslint-disable-next-line @glovo/no-console
            console.warn(`Invalid metric name ('${name}'). Service ('${service}') should be '${_service}'`);
        }
    }
    function sendMetric(metric, options) {
        validateMetricName(metric.name);
        const tags = mergeTags(_globalTags, options.tags);
        const timestamp = new Date().getTime();
        _integrations.forEach((integration) => {
            integration.send(Object.assign(Object.assign({}, metric), { tags, timestamp }));
        });
    }
    return {
        init({ integrations, tags, namespace, service } = { integrations: [] }) {
            _integrations = integrations !== null && integrations !== void 0 ? integrations : [];
            _globalTags = tags !== null && tags !== void 0 ? tags : [];
            _namespace = namespace !== null && namespace !== void 0 ? namespace : 'glovoapp';
            _service = service !== null && service !== void 0 ? service : 'client';
        },
        count(metric, value = 1, options = {}) {
            sendMetric({ name: metric, value, type: types_1.CustomMetricType.COUNT }, options);
        },
        gauge(metric, value, options = {}) {
            sendMetric({ name: metric, value, type: types_1.CustomMetricType.GAUGE }, options);
        },
        rate(metric, value, options = {}) {
            sendMetric({ name: metric, value, type: types_1.CustomMetricType.RATE }, options);
        },
        distribution(metric, value, options = {}) {
            sendMetric({ name: metric, value, type: types_1.CustomMetricType.DISTRIBUTION }, options);
        },
    };
}
exports.makeCustomMetricsSender = makeCustomMetricsSender;
//# sourceMappingURL=make-custom-metrics-sender.js.map